import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import BasicButton from '@/ui-components/BasicButton.vue';
import ProviderIcon from '@/components/picture/ProviderIcon.vue';

import { CollectionType } from '@/enums/collection-type';
import { OnboardingStatus } from '@/enums/onboarding-status';
import { Package } from '@/@types/graphql-types';

import { useRoute, useRouter } from 'vue-router/composables';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import { calculateUrl } from '@/helpers/state-helper';
import { useFilterStore, useUserStore, useRoutingStore, useConstantStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'UKHomeHero',
  props: {
    variant: null
  },
  emits: ['click'],
  setup(__props: any, { emit }) {

const props = __props as {
	variant: 'variant_1' | 'variant_2';
};

const { setFilterValue } = useFilterStore();
const { saveSettings, isLoggedIn, saveOnboardingStatus } = useUserStore();
const { fetchUrlMetadata } = useRoutingStore();
const { genresByShortName, subgenresList, providersByShortName, preselectedProviders, allProviders } =
	useConstantStore();
const route = useRoute();
const router = useRouter();





const DISCOVERY_INVITATION_EVENT_CATEGORY = 'discovery';
const collectionTypes = [CollectionType.POPULAR, CollectionType.NEW];

const providerList = computed(() => allProviders.value(false).slice(0, 13) as Package[]);
const providerListMobile = computed<Package[]>(() => providerList.value.slice(0, 6));

const providerUrls = computed(() =>
	Object.fromEntries(
		providerList.value.map(({ shortName }) => [
			shortName,
			calculateUrl(
				router,
				undefined,
				CollectionType.POPULAR,
				{ providers: [shortName] },
				providersByShortName.value,
				genresByShortName.value,
				subgenresList.value
			),
		])
	)
);

async function discoverClickHandler() {
	collectionTypes.forEach(collectionType => {
		setFilterValue({
			filterName: 'providers',
			filterValue: [],
			collectionType,
			updateRouteState: false,
		});
	});

	TrackingHelper.trackEvent(DISCOVERY_INVITATION_EVENT_CATEGORY, {
		action: 'invitation_clicked',
		property: 'top',
	});

	await saveSettings({ providers: preselectedProviders.value });

	saveOnboardingStatus(isLoggedIn.value ? OnboardingStatus.SIGNED_UP : OnboardingStatus.GLOBAL_CLICKED_CTA);

	await fetchUrlMetadata(route.path);

	emit('click');
}

function handleProviderClick(providerName: string) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'provider_clicked',
		property: providerName,
	});
}

function handleSeeAllClick() {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'provider_select_all_clicked',
	});
}

return { __sfc: true,setFilterValue, saveSettings, isLoggedIn, saveOnboardingStatus, fetchUrlMetadata, genresByShortName, subgenresList, providersByShortName, preselectedProviders, allProviders, route, router, emit, props, DISCOVERY_INVITATION_EVENT_CATEGORY, collectionTypes, providerList, providerListMobile, providerUrls, discoverClickHandler, handleProviderClick, handleSeeAllClick, BasicButton, ProviderIcon }
}

})